<template lang="pug">
    .important(
        :data-chapter='chapter',
        :data-section='section',
        :data-index='index'
        )
        p.important__item(
            v-for='(textsItem, textsIndex) in texts',
            :key='textsIndex',
            :data-important='kind',
            :data-chapter='chapter',
            :data-section='section',
            :data-index='index'
            :data-textindex='textsIndex + 1',
            )
            span.important__text(v-html='textsItem')
</template>

<script>
export default {
    name: 'Important',

    props: {
        kind: {
            type: Number,
            required: true
        },
        texts: {
            type: Array,
            required: true
        },
        chapter: {
            type: Number,
            required: true
        },
        section: {
            type: String,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    }
};
</script>

<style lang="scss">
@import '~poly-fluid-sizing';
@import '../assets/css/vars.scss';

.important {
    display: flex;
    margin: 0;

    &[data-chapter='1'] {
        &[data-section='bladeedge'] {
            &[data-index='3'] {
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-end;
                width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 10));

                @media (--viewport-tablet) {
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                }
            }

            &[data-index='5'] {
                position: absolute;
                top: 0;
                right: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3));
                margin-right: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }
        }

        &[data-section='bigbusiness'] {
            &[data-index='3'] {
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-end;
                width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 10));

                @media (--viewport-tablet) {
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                }
            }

            &[data-index='7'] {
                position: absolute;
                top: 0;
                left: 100%;
                width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 2));
                margin-left: var(--width-grid-column);

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }

            &[data-index='8'] {
                position: absolute;
                top: 0;
                right: 100%;
                width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 2));
                margin-right: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }

            &[data-index='10'] {
                margin-right: auto;
            }
        }

        &[data-section='spinningwheels'] {
            &[data-index='10'] {
                flex-direction: row;
                justify-content: space-between;
                align-items: flex-end;
                width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 10));

                @media (--viewport-tablet) {
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                }
            }

            &[data-index='12'] {
                position: absolute;
                top: 0;
                right: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3));
                margin-right: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }
        }
    }

    &[data-chapter='2'] {
        &[data-section='leaked'] {
            &[data-index='5'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }

            &[data-index='8'] {
                position: absolute;
                top: 0;
                right: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 2));
                margin-right: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }
        }

        &[data-section='everydaylife'] {
            &[data-index='1'] {
                position: absolute;
                top: 0;
                left: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-left: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0;
                }
            }

            &[data-index='6'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }

            &[data-index='8'] {
                position: absolute;
                top: 0;
                left: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-left: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: 100%;
                    margin: 0 0 2em;
                }
            }
        }

        &[data-section='playground'] {
            &[data-index='4'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }

        &[data-section='ukrainian'] {
            &[data-index='3'] {
                position: absolute;
                top: 0;
                left: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-left: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0 0 2em;
                }
            }

            &[data-index='6'] {
                position: absolute;
                top: 0;
                right: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-right: var(--width-grid-gap);

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0 0 2em;
                }
            }
        }

        &[data-section='rules'] {
            &[data-index='4'] {
                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }

            &[data-index='7'] {
                position: absolute;
                top: 0;
                left: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-left: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0 0 2em;
                }
            }
        }

        &[data-section='banana'] {
            &[data-index='0'] {
                position: absolute;
                top: 0;
                left: 100%;
                flex-direction: column;
                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 2));
                margin-left: calc(var(--width-grid-column) + var(--width-grid-gap));

                @media (--viewport-tablet) {
                    position: static;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;
                    width: calc((var(--width-grid-column-mobile) * 4) + (var(--width-grid-gap-mobile) * 5));
                    margin: 0 0 2em;
                }
            }

            &[data-index='5'] {
                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }
    }

    &[data-chapter='3'] {
        &[data-section='block'] {
            &[data-index='4'] {
                flex-direction: column;
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }

            &[data-index='10'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }

        &[data-section='agreed'] {
            &[data-index='5'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }

        &[data-section='legal'] {
            &[data-index='5'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }

        &[data-section='priceofpiracy'] {
            &[data-index='5'] {
                width: 100%;
                padding-left: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3) + var(--width-grid-left));

                @media (--viewport-tablet) {
                    padding-left: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                    padding-right: calc(var(--width-grid-column-mobile) + var(--width-grid-gap-mobile));
                }
            }
        }
    }

    &__item {
        margin: 0;

        &[data-important='1'] {
            position: relative;
            margin: 0;
            text-transform: uppercase;
            font-family: var(--font-title);
            font-weight: var(--font-title-weight);
            font-style: var(--font-title-style);
            line-height: 1.15;
            font-size: 60px;

            $mapFontSize: (
                320px: 20px,
                1920px: 60px
            );
            @include poly-fluid-sizing('font-size', $mapFontSize);

            &::before {
                content: '';
                position: absolute;
            }

            em {
                position: relative;
                display: inline-block;
                text-transform: none;
            }

            &[data-chapter='1'] {
                &[data-section='bladeedge'] {
                    &[data-textindex='1'] {
                        width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 5));

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 4));
                            margin-bottom: 1em;
                        }

                        &::before {
                            top: 1.15em;
                            left: -3em;
                            width: 100%;
                            height: 2em;
                            background: url('../assets/img/important/1-1.svg') no-repeat 50% 50% / contain;
                        }
                    }

                    &[data-textindex='2'] {
                        width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 4));

                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                        }

                        &::before {
                            top: 1.15em;
                            left: -2.5em;
                            width: calc(100% + var(--width-grid-column) + var(--width-grid-gap));
                            height: 2em;
                            background: url('../assets/img/important/1-2-1.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            &::before {
                                content: '';
                                position: absolute;
                                top: -0.5em;
                                bottom: -0.5em;
                                left: -1em;
                                width: 100%;
                                background: url('../assets/img/important/1-2-2.svg') no-repeat 50% 50% / contain;
                            }
                        }
                    }
                }

                &[data-section='bigbusiness'] {
                    &[data-textindex='1'] {
                        width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 5));

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 4));
                            margin-bottom: 1em;
                        }

                        &::before {
                            top: 1.45em;
                            left: -3em;
                            width: 100%;
                            height: 2em;
                            background: url('../assets/img/important/2-1.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            vertical-align: -0.3em;
                            font-size: 2em;
                        }
                    }

                    &[data-textindex='2'] {
                        width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 4));

                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                        }

                        &::before {
                            top: 0;
                            left: -2em;
                            width: calc(100% + var(--width-grid-column) + var(--width-grid-gap));
                            height: 2em;
                            background: url('../assets/img/important/2-2.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            font-size: 1.3em;

                            &::before {
                                content: '';
                                position: absolute;
                                top: -0.5em;
                                bottom: -0.5em;
                                left: -0.5em;
                                width: 100%;
                                background: url('../assets/img/important/1-2-2.svg') no-repeat 50% 50% / contain;
                            }
                        }
                    }
                }

                &[data-section='spinningwheels'] {
                    &[data-textindex='1'] {
                        width: calc((var(--width-grid-column) * 5) + (var(--width-grid-gap) * 5));

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 4));
                            margin-bottom: 1em;
                        }

                        &::before {
                            top: 1.1em;
                            left: calc((var(--width-grid-column) + var(--width-grid-gap)) * -1);
                            width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 4));
                            height: 2.4em;
                            background: url('../assets/img/important/4-1.svg') no-repeat 50% 50% / contain;
                        }
                    }

                    &[data-textindex='2'] {
                        width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 4));

                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                        }

                        &::before {
                            top: 1.1em;
                            left: -0.9em;
                            width: calc(100% + var(--width-grid-gap));
                            height: 2.4em;
                            background: url('../assets/img/important/4-2.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            &::before {
                                content: '';
                                position: absolute;
                                top: -0.5em;
                                bottom: -0.5em;
                                left: -1.5em;
                                width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 3));
                                background: url('../assets/img/important/1-2-2.svg') no-repeat 50% 50% / contain;
                            }
                        }
                    }
                }

                em {
                    color: var(--color-accent-1);
                }
            }

            &[data-chapter='3'] {
                &[data-section='block'] {
                    &[data-index='4'] {
                        width: calc((var(--width-grid-column) * 6) + (var(--width-grid-gap) * 6));

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &:not(:last-child) {
                            margin-bottom: 0.5em;
                        }

                        em {
                            font-size: 1.3em;
                        }

                        strong {
                            font-size: 1.5em;
                            color: var(--color-accent-3);

                            @supports (-webkit-text-stroke-color: white) {
                                -webkit-text-fill-color: transparent;
                                -webkit-text-stroke-color: currentColor;
                                -webkit-text-stroke-width: 2px;

                                @media (--viewport-tablet) {
                                    -webkit-text-stroke-width: 1px;
                                }
                            }
                        }

                        &[data-textindex='2'] {
                            background: url('../assets/img/important/11-1.svg') no-repeat 50% 0 / contain;
                        }

                        &[data-textindex='4'] {
                            background: url('../assets/img/important/11-2.svg') no-repeat 0 0 / auto 2.5em;
                        }
                    }
                }

                &[data-section='legal'] {
                    &[data-index='5'] {
                        width: calc((var(--width-grid-column) * 4) + (var(--width-grid-gap) * 5));

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 4));
                            margin-bottom: 1em;
                        }

                        &::before {
                            top: 1.15em;
                            left: -1.5em;
                            width: 100%;
                            height: 2.5em;
                            background: url('../assets/img/important/12.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            font-size: 1.3em;
                        }
                    }
                }

                em {
                    color: var(--color-accent-3);
                }
            }
        }

        &[data-important='2'] {
            position: relative;
            margin: 0;
            text-transform: uppercase;
            font-family: var(--font-title);
            font-weight: var(--font-title-weight);
            font-style: var(--font-title-style);
            line-height: 1.2;
            font-size: 30px;

            $mapFontSize: (
                320px: 20px,
                1920px: 30px
            );
            @include poly-fluid-sizing('font-size', $mapFontSize);

            &::before {
                content: '\2014';
                position: absolute;
                top: -0.5em;
                left: -0.4em;
                font-size: 4em;
                line-height: 1;
                color: var(--color-accent-1);

                @supports (-webkit-text-stroke-color: white) {
                    -webkit-text-fill-color: transparent;
                    -webkit-text-stroke-color: currentColor;
                    -webkit-text-stroke-width: 2px;

                    @media (--viewport-tablet) {
                        -webkit-text-stroke-width: 1px;
                    }
                }
            }

            em {
                position: relative;
                display: inline-block;
                text-transform: none;
                font-size: 2em;

                @supports (-webkit-text-stroke-color: white) {
                    -webkit-text-fill-color: transparent;
                    -webkit-text-stroke-color: currentColor;
                    -webkit-text-stroke-width: 2px;

                    @media (--viewport-tablet) {
                        -webkit-text-stroke-width: 1px;
                    }
                }
            }

            &[data-chapter='1'] {
                &::before,
                em {
                    color: var(--color-accent-1);
                }

                &[data-section='bladeedge'] {
                    &[data-textindex='1'] {
                        margin-bottom: 2em;

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }

                    &[data-textindex='2'] {
                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }
                }

                &[data-section='bigbusiness'] {
                    &[data-textindex='1'] {
                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }

                        .content__important[data-section='bigbusiness'][data-textindex='8'] & {
                            align-self: flex-end;
                        }
                    }
                }

                &[data-section='spinningwheels'] {
                    &[data-textindex='1'] {
                        margin-bottom: 2em;

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }

                    &[data-textindex='2'] {
                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }
                }
            }

            &[data-chapter='2'] {
                &::before,
                em {
                    color: var(--color-accent-2);
                }

                &[data-section='leaked'] {
                    &[data-textindex='1'] {
                        margin-bottom: 2em;

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }

                    &[data-textindex='2'] {
                        @media (--viewport-tablet) {
                            align-self: flex-end;
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 3));
                            margin-bottom: 1em;
                        }
                    }
                }

                &[data-section='everydaylife'] {
                    &[data-index='1'] {
                        margin-bottom: 2em;
                    }

                    &[data-index='8'] {
                        margin-bottom: 0.7em;

                        &::before {
                            display: none;
                        }

                        em {
                            display: block;
                            margin-left: calc(var(--width-grid-gap) * -1);
                        }
                    }
                }
            }

            &[data-chapter='3'] {
                &::before {
                    color: var(--color-accent-3);
                }
            }
        }

        &[data-important='3'] {
            position: relative;
            margin: 0;
            text-transform: uppercase;
            font-family: var(--font-title);
            font-weight: var(--font-title-weight);
            font-style: var(--font-title-style);
            line-height: 1.15;
            font-size: 60px;

            $mapFontSize: (
                320px: 20px,
                1920px: 60px
            );
            @include poly-fluid-sizing('font-size', $mapFontSize);

            &[data-chapter='1'] {
                &[data-section='bigbusiness'] {
                    &[data-textindex='1'] {
                        width: calc((var(--width-grid-column) * 5) + (var(--width-grid-gap) * 6));

                        @media (--viewport-tablet) {
                            width: calc((var(--width-grid-column-mobile) * 3) + (var(--width-grid-gap-mobile) * 4));
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.2em;
                            left: 0;
                            width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 3));
                            height: 1.5em;
                            background: url('../assets/img/important/3.svg') no-repeat 50% 50% / contain;
                        }

                        em {
                            vertical-align: -0.3em;
                            font-size: 1.5em;
                            text-transform: none;
                            color: var(--color-accent-1);
                        }
                    }
                }
            }

            &[data-chapter='2'] {
                &[data-section='leaked'] {
                    &[data-index='5'] {
                        width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 9));

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            top: 2em;
                            left: -1em;
                            width: 100%;
                            height: 3em;
                            background: url('../assets/img/important/5.svg') no-repeat 50% 50% / contain;
                        }
                    }

                    &[data-index='11'] {
                        width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 9));

                        &::before {
                            content: '';
                            position: absolute;
                            top: 1em;
                            left: -1em;
                            width: 100%;
                            height: 1.5em;
                            background: url('../assets/img/important/6.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }

                &[data-section='everydaylife'] {
                    &[data-index='6'] {
                        width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 9));

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.5em;
                            left: -1em;
                            width: 100%;
                            height: 1.5em;
                            background: url('../assets/img/important/7.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }

                &[data-section='playground'] {
                    &[data-index='4'] {
                        width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 9));

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.7em;
                            left: 0em;
                            width: 100%;
                            height: 3em;
                            background: url('../assets/img/important/8.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }

                &[data-section='rules'] {
                    &[data-index='4'] {
                        width: calc((var(--width-grid-column) * 10) + (var(--width-grid-gap) * 10));

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.7em;
                            left: 0em;
                            width: 100%;
                            height: 2em;
                            background: url('../assets/img/important/9.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }

                &[data-section='banana'] {
                    &[data-index='3'] {
                        font-family: var(--font-title);
                        font-weight: var(--font-title-weight);
                        font-style: var(--font-title-style);
                        line-height: 0.86;
                        font-size: 273px;
                        color: var(--color-accent-2);

                        $mapFontSize: (
                            320px: 80px,
                            768px: 170px,
                            769px: 100px,
                            1920px: 273px
                        );
                        @include poly-fluid-sizing('font-size', $mapFontSize);

                        @supports (-webkit-text-stroke-color: white) {
                            -webkit-text-fill-color: transparent;
                            -webkit-text-stroke-color: currentColor;
                            -webkit-text-stroke-width: 2px;
                        }
                    }

                    &[data-index='5'] {
                        width: calc((var(--width-grid-column) * 9) + (var(--width-grid-gap) * 9));

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            top: -0.4em;
                            left: 0;
                            width: 100%;
                            height: 4em;
                            background: url('../assets/img/important/10.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }
            }

            &[data-chapter='3'] {
                &[data-section='block'] {
                    &[data-index='10'] {
                        width: calc((var(--width-grid-column) * 8) + (var(--width-grid-gap) * 8));
                        font-size: 60px;

                        $mapFontSize: (
                            320px: 20px,
                            1920px: 40px
                        );
                        @include poly-fluid-sizing('font-size', $mapFontSize);

                        @media (--viewport-tablet) {
                            width: 100%;
                        }
                    }
                }

                &[data-section='agreed'] {
                    &[data-index='5'] {
                        width: calc((var(--width-grid-column) * 8) + (var(--width-grid-gap) * 8));
                        font-size: 40px;

                        $mapFontSize: (
                            320px: 20px,
                            1920px: 40px
                        );
                        @include poly-fluid-sizing('font-size', $mapFontSize);

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.5em;
                            left: 0;
                            width: calc((var(--width-grid-column) * 2) + (var(--width-grid-gap) * 2));
                            height: 2em;
                            background: url('../assets/img/important/13.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }

                &[data-section='priceofpiracy'] {
                    &[data-index='5'] {
                        width: calc((var(--width-grid-column) * 8) + (var(--width-grid-gap) * 8));
                        font-size: 60px;

                        $mapFontSize: (
                            320px: 20px,
                            1920px: 40px
                        );
                        @include poly-fluid-sizing('font-size', $mapFontSize);

                        @media (--viewport-tablet) {
                            width: 100%;
                        }

                        &::before {
                            content: '';
                            position: absolute;
                            bottom: -0.5em;
                            left: 0;
                            width: calc((var(--width-grid-column) * 3) + (var(--width-grid-gap) * 3));
                            height: 2em;
                            background: url('../assets/img/important/14.svg') no-repeat 50% 50% / contain;
                        }
                    }
                }
            }
        }
    }

    &__text {
        position: relative;
    }
}
</style>
